import type { QueryClient } from "@tanstack/react-query";
import { QUERIES } from "modules/common/query";

export type InventoryFacetScope = "collection" | "trade";

/**
 * Invalidate every facet/appraisal query for the affected inventory scope.
 * Binder keys carry a request object while legacy details keys carry a list or
 * collection ID, so the shared query-family prefix is the canonical boundary.
 */
export function invalidateInventoryFacetQueries(
  queryClient: QueryClient,
  ...scopes: InventoryFacetScope[]
) {
  const uniqueScopes = [...new Set(scopes)];
  return Promise.all(
    uniqueScopes.map((scope) =>
      queryClient.invalidateQueries({
        queryKey: [
          scope === "collection"
            ? QUERIES.COLLECTION_FACETS
            : QUERIES.TRADE_LIST_FACETS,
        ],
      })
    )
  );
}
